import Molde from "./MoldeTrek";
import CardLugar from "../common/card/CardLugar";
import CardRecomienda from "../common/card/CardRecomienda";
import CardCaracteristica from "../common/card/CardCaracteristica";
import React from 'react';


export default function Caminoinca4x3() {

  const tourItemsIncluye = [
  "Información previa al tour: Te reunirás con tu guía del Camino Inca en nuestras oficinas (u otro lugar acordado) alrededor de las 18:00 horas para una sesión informativa sobre su viaje.",
  "Transporte turístico “Cusco – Ollantaytambo” (ida y vuelta).",
  "Tren turístico “Expediciones” al Km 104, Chachabamba.",
  "Tren turístico “Expediciones” de Aguas Calientes a Ollantaytambo.",
  "03 Buses Consettur a ciudadela de Machu Picchu (bajada, subida y bajada).",
  "Guía profesional altamente calificado de habla inglesa y española en el Camino Inca.",
  "Guía profesional altamente calificado de habla inglesa y española en Machu Picchu.",
  "Ticket de ingreso al Camino Inca corto.",
  "Ticket de ingreso a la ciudadela Inca de Machu Picchu (Casa del Guardian, Circuito 1 y Circuito 3).",
  "Hotel en Aguas Calientes incluido, brindándote todos los servicios que necesitarás: agua caliente, baño privado, Wi-Fi y desayuno.",
  "1 desayuno, 1 almuerzo para llevar, 1 cena (Opciones: vegetariana, vegana, sin gluten, etc.).",
  "Botiquín de primeros auxilios y tanque de oxígeno. (Nuestros guías están altamente capacitados en primeros auxilios y rescate en montaña, con un plan integral de atención, evacuaciones terrestres y evacuaciones aéreas)",
  "Servicio de Atención al Cliente las 24 horas: Ofrecemos un servicio telefónico disponible las 24 horas del día.",
  "Almacen de equipaje gratuito (Free): Brindamos resguardo de equipaje en nuestras oficinas en Cusco. Podrás dejar tu equipaje antes de iniciar tu recorrido (exclusivo para nuestros pasajeros)."
];
const tourItemsNoIncluye = [
"Los bastones de trekking no están incluidos, pero se recomiendan para la caminata. Puedes alquilar con nosotros o llevar unas propias.",
"Ingreso a sitios adicionales (Huayna Picchu / Montaña Machupicchu*).",
"El almuerzo en el 2do día y desayuno en el 1er día.",
"Additional costs or delays beyond our control, such as natural disasters, adverse weather conditions, itinerary modifications due to passenger health issues (suffering from an illness or health problems), pandemic, changes in government policies, political instability, strikes, etc."

];
const extras =[
  "Bastones de trekking. ($15.00 USD)",
  "Almuerzo Económico en Aguas Calientes. ($15.00 USD)",
  "Almuerzo en Sanctuary Lodge. ($45.00 USD)",
  "Ingreso a Wayna Picchu, sujeto a disponibilidad y horarios: 7:00 am / 8:00 am / 9:00 am / 10:00 am ($60.00 USD)",
  "Entrada montaña Machupicchu*, sujeto a disponibilidad y horarios: 8:00 am / 9:00 am ($60.00 USD)",
  "Tour guiado por Huayna Picchu o montaña Machupicchu *. ($75.00 USD por grupo)",
  "Actualice su servicio de tren Vistadome en el regreso. ($50.00 USD)",
  "Actualice su servicio de tren Vistadome Observatory en el regreso. ($75.00 USD)",
  "Camping bajo solicitud. ($50.00 USD)",
  "Podemos ayudarle en la reserva de hoteles (estándar y de lujo) en todo el Perú."
];
const llevar =[
  "Pasaporte original (y Carnet de estudiante vigente si aplicó a esta opción).",
  "Botas / zapatos para caminar.",
  "Casaca impermeable / poncho de lluvia.",
  "Chaqueta, gorro y guantes abrigados.",
  "Polos manga corta o larga.",
  "Pantalones cómodos.",
  "Sombrero para el sol.",
  "Gafas de sol.",
  "Crema de protección solar (se recomienda factor 35)",
  "Botellas de plástico o metal reutilizable, o camelbak.",
  "Agua, en el camino es posible comprar botellas de agua de las familias locales.",
  "Repelente de insectos.",
  "Medicación personal.",
  "Cámara y filmadora.",
];
const arti_adi=[
  "Pantalones cortos.",
  "Bastón (con punta de goma).",
  "Yesos y vendajes.",
  "Sandalias.",
  "Traje de baño.",
  "Dinero extra para gastos personales, propinas (se recomiendan 200 nuevos soles peruanos para el dinero extra)",
  ];
const importante=[
  "El itinerario puede cambiar debido a disposiciones del gobierno peruano, condiciones climáticas y el estado de salud de los excursionistas.",
  "El horario del tren puede variar según la disponibilidad de la empresa ferroviaria.",
  "Ofrecemos el tren Expedition hacia Ollantaytambo: si alguien reserva su billete de tren a última hora, no se garantiza que pueda estar en el mismo tren que el resto del grupo.",
  "Si deseas cambiar el horario o los boletos de tu tren, deberás pagar un cargo adicional por el transporte desde Ollantaytambo a Cusco y por la diferencia en el precio del tren.",
];
  return (
    <>
      <Molde
        image={"/images/portada_camino_inca.png"}
        title={"CAMINO INCA 4D/3N"}
        subtitle={"4 DIAS / 3 NOCHE"}
        description={
          "Experimente el increible Camino Inca Corto en 2 días, una combinación de aventura y lujo diseñada para aquellos con tiempo limitado. Con una duración de 12 km, esta caminata pasa a través de exuberantes paisajes del valle de Urubamba y fauna diversa, sumergiéndote en senderos antiguos. Los lugares más destacados que incluye son Wiñayhuayna, Inti Punku Puerta del Sol, La casa del Guardián con impresionantes vistas de Machu Picchu y el Santuario de Machu Picchu y sus cautivadores momentos del atardecer y el amanecer. Somos una agencia de viajes y operadores locales en Cusco autorizada, ofrecemos salidas diarias, aunque se recomienda reservar con anticipación debido al límite de visitantes del Camino Inca."
        }
        linkForm={"/reservar/citytour-dia"}
        /*tipoprecio={"Precio por persona"}
        monto={"US$ 1250.00"}
        moneda={"DOLARES"}*/
        mapa={
          <>
            
            <img className="rounded-lg border-primary-800 border-2" src={`${process.env.PUBLIC_URL}/images/mapa_camino_inca.png`} alt="" />
          </>
        }
        itinerario={<>
            <div className="mb-4">
                                <h1 className="font-bold text-primary-800 pb-4">ITINERARIO</h1>
                                <div className="bg-primary-800 p-2 rounded-lg w-full">
                                  <h2 className="text-primary-50 font-bold">Día 1 | INCA TRAIL</h2>
                                </div>
                                <h4 className="text-primary-800 py-4 font-semibold">Caminata Piscacucho Km 82 – Wayllabamba</h4>
                                <img className="w-full rounded-lg " src={`${process.env.PUBLIC_URL}/images/camino_inca_1_1.png`} alt="" />
                                <div className="mt-2 text-primary-800">
                                    <p className="mb-2">Nuestro viaje a Machu Picchu comienza con el recojo de su hotel alrededor de las 5:00 a.m. por parte de su guía. Pasaremos por Ollantaytambo alrededor de las 6:30 a.m. con un descanso de 40 minutos para desayunar y la oportunidad de comprar souvenirs. Posteriormente nos dirigiremos hacia Piscacucho, conocido como kilómetro 82, donde comienza nuestra increíble caminata Camino Inca. (El desayuno no está incluido). Alrededor de las 9:30 a.m. llegaremos al kilómetro 82, primer punto de control del Camino Inca, donde debemos presentar nuestro permiso de Camino Inca, pasaportes originales e identificación de estudiante (si aplica para descuento de estudiante).</p>
                                  <p className="mb-2">Al inicio del sendero (2720 m / 8923 pies), cruzaremos el río Vilcanota, caminando por aproximadamente 2 horas hasta llegar a Miskay (2690 m / 8825 pies), donde disfrutaremos de un delicioso almuerzo.</p>
                                  <p className="mb-2">El primer día es relativamente fácil y sirve como calentamiento a lo largo del terreno llano Inca. Hay excelentes vistas de la Fortaleza Inca 'Willca Raccay' (2750 m / 9022 pies), el vasto e increíble sitio Inca de Llactapata (oficialmente llamado 'Patallacta') y el hermoso pico nevado de 'Wakay Willca' (5860 m / 19225 pies), conocida como Verónica. Nuestro primer campamento es en Wayllabamba (3000 m / 9842 pies). Llegaremos allí a las 17:00 horas, y al llegar tendremos un momento para disfrutar de "tarde de té", bebidas calientes y galletas para luego disfrutar de una agradable cena preparada por nuestro chef profesional personal aproximadamente a las 18:30 horas. Después de la cena, nos instalaremos para pasar la noche. Las temperaturas nocturnas rondan los 5°C, según el mes.</p>

                                </div>
                              </div>
                              <div>
                                <div className="bg-primary-800 p-2 rounded-lg w-full">
                                  <h2 className="text-primary-50 font-bold">Día 2 | INCA TRAIL</h2>
                                </div>
                                <h4 className="text-primary-800 py-4 font-semibold">Caminata Wayllabamba – Warmiwañuska</h4>
                                <img className="w-full rounded-lg " src={`${process.env.PUBLIC_URL}/images/camino_inca_1_2.png`} alt="" />
                                <div className="mt-2 text-primary-800">
                                    <p className="mb-2">Comenzaremos el día con un abundante desayuno a las 5:30 a.m., alimentaremos nuestro cuerpo para la desafiante subida que se avecina.</p>
                                    <p className="mb-2">Emprenderemos un empinado ascenso hacia el Abra de Warmiwañusca, también conocido como el "Paso de la Mujer Muerta". A 4215 m / 13829 pies, este será el punto más alto de todo el Camino Inca. ¡Alcanzar la cumbre será un logro que te llenará de orgullo!</p>
                                    <p className="mb-2">Luego de un merecido descanso, descenderemos a Pacaymayo 3,600 m / 11,811 pies para disfrutar de un delicioso almuerzo, durante el descenso deleitaremos nuestros sentidos con la diversidad de flora y fauna de la zona. Observaremos coloridas especies de colibríes y otras aves, y admiraremos la impresionante variedad de plantas nativas, incluidos los majestuosos árboles Q'ueuña que prosperan en el hermoso bosque nuboso.</p>
                                    <p className="mb-2">Campamento Pacaymayo: Alrededor de las 6:30 p. m., estaremos listos para descansar bajo las estrellas. Esté preparado para las noches frías, ya que las temperaturas aquí suelen bajar a unos 4 °C.</p>
                                </div>
                              </div>
                              <div>
                                <div className="bg-primary-800 p-2 rounded-lg w-full">
                                  <h2 className="text-primary-50 font-bold">Día 3 | INCA TRAIL</h2>
                                </div>
                                <h4 className="text-primary-800 py-4 font-semibold">Caminata Pacaymayu – Runkurakay – Phuyupatamarka - Intipata - Wiñay Wayna</h4>
                                <img className="w-full rounded-lg " src={`${process.env.PUBLIC_URL}/images/camino_inca_1_3.png`} alt="" />
                                <div className="mt-2 text-primary-800">
                                    <p className="mb-2">Despierte con un buen desayuno a las 6:00 a. m. y recargue sus energías para un día de caminatas panorámicas y descubrimientos históricos. Hoy nos embarcamos en un viaje especial, pasando por lo menos por tres majestuosas ruinas incas en medio de paisajes impresionantes.</p>
                                    <p className="mb-2">7:00 am: Ascenso a Runkuraqay y Paso Runkurakay. Nuestro primer desafío es una subida cuesta arriba de una hora para llegar a Runkuraqay, una impresionante ruina inca situada a 3,750 metros. Desde aquí continuamos ascendiendo durante una hora más para conquistar el segundo punto más alto del Camino Inca, el paso Runkurakay, situado a 3.950 metros. Contempla las vistas panorámicas de las montañas y valles circundantes: ¡una recompensa por nuestros esfuerzos!</p>
                                    <p className="mb-2">Sayacmarka y Chakiccocha: Después de conquistar los dos picos, disfrutaremos de una cómoda caminata cuesta abajo de 45 minutos hasta Sayacmarka, una encantadora ciudadela inca ubicada a 3,650 metros. Exploraremos su fascinante arquitectura y disfrutaremos de las vistas panorámicas. Continuaremos el viaje con una caminata de 25 minutos hasta Chakiccocha, donde nos espera un delicioso almuerzo en medio de un entorno natural idílico.</p>
                                    <p className="mb-2">Phuyupatamarca: Reabastecidos y rejuvenecidos, nos embarcamos en la última caminata del día por el Camino Inca: una subida de una hora a Phuyupatamarca, otra impresionante construcción inca ubicada a 3.600 metros. Sumérgete en la historia y maravíllate con las vistas panorámicas.</p>
                                    <p className="mb-2">Descenso al campamento de Wiñay Huayna. Alrededor de las 3:00 p.m., descenderemos durante dos horas tranquilamente por un sendero suave hasta Wiñay Huayna, nuestro campamento final ubicado a 2,680 metros. Relájese y disfrute de la belleza del entorno, sabiendo que ha conquistado el increible Camino Inca.</p>
                                    <p className="mb-2">Alrededor de las 6:30 p.m. tendremos un Buffet de Despedida y Exploración Opcional. Nuestros increíbles chefs preparan una suntuosa cena y despediremos a nuestros porters que nos acompañan hasta este campamento.</p>                                    <p>Recuerdos Inolvidables y una Noche en Wiñay Huayna. Recuerde los logros de hoy son igual de increibles que nuestro último destino al día siguiente, Machu Picchu. Duerme profundamente en nuestro campamento Wiñay Huayna, sabiendo que has vivido uno de los días más impresionantes del Camino Inca. Las temperaturas nocturnas rondarán los 12°C.</p>
                                </div>
                              </div>
                              <div>
                                <div className="bg-primary-800 p-2 rounded-lg w-full">
                                  <h2 className="text-primary-50 font-bold">Día 4 | INCA TRAIL</h2>
                                </div>
                                <h4 className="text-primary-800 py-4 font-semibold">Wiñay Wayna – Inti Punku “Puerta del Sol” – Machu Picchu (Circuito 1 y 3) – Cusco.</h4>
                                <img className="w-full rounded-lg " src={`${process.env.PUBLIC_URL}/images/camino_inca_1_4.png`} alt="" />
                                <div className="mt-2 text-primary-800">
                                    <p className="mb-2">En este último día, comience temprano con un abundante desayuno antes de dirigirse al primer punto de control, que abre a las 5:30 a. m. Te espera un emocionante ascenso de una hora que te llevará a la Puerta del Sol, donde serás recibido por impresionantes vistas de Machu Picchu y las majestuosas montañas de los Andes.</p>
                                    <p className="mb-2">Prepárese para quedar asombrado. Tome un merecido descanso de 20 minutos en la Puerta del Sol , sumérjase en el panorama, antes de un descenso final de 10 minutos a la legendaria ciudad perdida de los Incas. El Camino Inca culmina aquí, dejándote en el umbral de la maravilla.</p>
                                    <p className="mb-2">Ingresando a Machu Picchu : Pase por el segundo control y deje sus mochilas (3 soles por bolsa) mientras se adentra en la maravilla de esta antigua ciudad. Asegúrese de tener a mano su pasaporte, boleto de entrada y tarjeta de estudiante (si corresponde).</p>
                                    <p className="mb-2">Descubriendo los secretos de Machu Picchu : entre las 8:00 y las 10:00 a. m., su guía lo llevará a través de los cautivadores alrededores de Machu Picchu, descubriendo las historias y el significado de sus templos, ruinas y rincones escondidos.</p>
                                    <p className="mb-2">Escalada para disfrutar de la gloria panorámica : Para los buscadores de aventuras, el ascenso opcional al Huayna Picchu (2 horas de ida y vuelta) o a la Montaña Machu Picchu (3 horas de ida y vuelta) ofrece impresionantes vistas aéreas de toda la ciudad. Los boletos son necesarios y se agotan rápidamente, así que planifique en consecuencia .</p>
                                </div>
                              </div>
                            </>
        }
        galeria={
            <>
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/colores_1.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/colores_2.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/colores_3.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/colores_4.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/colores_5.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/colores_6.png`} alt="" />
            </>
          }
        incluye={
          <ul className="space-y-3">
            {tourItemsIncluye.map((item, index) => (
              <li key={index} className="flex items-start gap-2 text-sm text-gray-700">
                <span className="text-green-600 font-bold mt-1">✔</span>
                <span className="text-primary-800">{item}</span>
              </li>
            ))}
          </ul>
        }
        
        noIncluye={
          <ul className="space-y-3">
            {tourItemsNoIncluye.map((item, index) => (
              <li key={index} className="flex items-start gap-2 text-sm text-gray-700">
                <span className="text-red-600 font-bold mt-1">✖</span>
                <span className="text-primary-800">{item}</span>
              </li>
            ))}
          </ul>
        }
        extras={
          <ul className="space-y-3">
            {extras.map((item, index) => (
              <li key={index} className="flex items-start gap-2 text-sm text-gray-700">
                <span className="text-blue-600 font-bold mt-1">➕</span>
                <span className="text-primary-800">{item}</span>
              </li>
            ))}
          </ul>
        }
        llevarTrek={
          <ul className="space-y-3">
            {llevar.map((item, index) => (
              <li key={index} className="flex items-start gap-2 text-sm text-gray-700">
                <span className="text-blue-600 font-bold mt-1">➕</span>
                <span className="text-primary-800">{item}</span>
              </li>
            ))}
          </ul>
        }
        articulo_add={
          <ul className="space-y-3">
            {arti_adi.map((item, index) => (
              <li key={index} className="flex items-start gap-2 text-sm text-gray-700">
                <span className="text-blue-600 font-bold mt-1">➕</span>
                <span className="text-primary-800">{item}</span>
              </li>
            ))}
          </ul>
        }
        importante={
          <ul className="space-y-3">
          {importante.map((item, index) => (
            <li key={index} className="flex items-start gap-2 text-sm text-gray-700">
              <span className="text-yellow-600 font-bold mt-1">❗</span>
              <span>{item}</span>
            </li>
          ))}
        </ul>
        }

        caracteristica={
          <>
            <CardCaracteristica
              icon={`${process.env.PUBLIC_URL}/icons/level.svg`}
              title={"Dificultad"}
              desc={"Dificil"}
            />
            <CardCaracteristica
              icon={`${process.env.PUBLIC_URL}/icons/compartido.svg`}
              title={"Tipo Servicio"}
              desc={"4/10 personas"}
            />
            <CardCaracteristica
              icon={`${process.env.PUBLIC_URL}/icons/duracion.svg`}
              title={"Duración"}
              desc={"4 Días/3 Noche"}
            />
            <CardCaracteristica
              icon={`${process.env.PUBLIC_URL}/icons/cultural.svg`}
              title={"Tipo de Tour"}
              desc={"Trekking"}
            />
          </>
        }
        
        TourRecomienda={
                  <>
                    <CardRecomienda
                      img={"/images/montania_colores.png"}
                      title={"MONTAÑA 7 COLORES"}
                      puntuacion={"4.5"}
                      link={'/tour-tradicional/montania-colores'}
                    />
                    <CardRecomienda
                      img={"/images/valle-vip-5.png"}
                      title={"VALLE VIP"}
                      puntuacion={"5"}
                      link={'/tour-tradicional/valle-vip'}
                    />
                    <CardRecomienda
                      img={"/images/cris-1.png"}
                      title={"CITY TOUR"}
                      puntuacion={"5"}
                      link={'/tour-tradicional/citytour'}
                    />
                    <CardRecomienda
                      img={"/images/maras-moray-4.png"}
                      title={"MARAS-MORAY"}
                      puntuacion={"4.5"}
                      link={'/tour-tradicional/maras-moray'}
                    />
                  </>
                }
      />
    </>
  );
}
